module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svg-sprite-84e6ba0859b67d2a822c8ad28bb7a5bc.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }